import DialogContentText from "@material-ui/core/DialogContentText";
import ActionDialog from "@saleor/components/ActionDialog";
import { ConfirmButtonTransitionState } from "@saleor/components/ConfirmButton";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";


export interface CountryBulkDeleteDialog {
    confirmButtonState: ConfirmButtonTransitionState;
    quantity: number;
    open: boolean;
    onConfirm: () => void;
    onClose: () => void;
  }

const CountryBulkDeleteDialog :React.FC<CountryBulkDeleteDialog> = ({
    confirmButtonState,
    quantity,
    onClose,
    onConfirm,
    open
  }) => {
    const intl = useIntl();
    return(
        <ActionDialog
            open={open}
            confirmButtonState={confirmButtonState}
            onClose={onClose}
            onConfirm={onConfirm}
            title={intl.formatMessage({
            defaultMessage: "Delete country",
            description: "dialog title"
            })}
            variant="delete"
        >
        <DialogContentText>
          <FormattedMessage
            defaultMessage="{counter,plural,one{Are you sure you want to delete this country?} other{Are you sure you want to delete {displayQuantity} countries?}}"
            description="dialog content"
            values={{
              counter: quantity,
              displayQuantity: <strong>{quantity}</strong>
            }}
          />
        </DialogContentText>
      </ActionDialog>
    );
  };
  export default CountryBulkDeleteDialog;
  